import React, {Fragment, useEffect, useState} from "react";
import {connect} from "react-redux";
import io from "socket.io-client";
import 'moment/locale/ru';
import {Card, Form, FormGroup, Label, Input, Modal, ModalBody, ModalHeader,} from "reactstrap";
import {Route, Switch} from 'react-router-dom';
import get from 'lodash/get';
import {useTranslation} from "react-i18next";

import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import {
    addingNewContactToggleModal,
    addingNewContactRequestStart,
    addingNewContactTouchForm,
    importNewContactsToggleModal,
    importNewContactsRequestStart,
    importNewContactsTouchForm
} from "../../actions/Chats";
import {isMobileDevice} from '../../index';
import Chats from "./Chats/index";
import Messages from "./Messages/index";
import ChatDetail from "./Detail/ChatDetail";
import ButtonWithSpinner from "../../Components/ButtonWithSpinner";
import DragDropFile from "../../Components/DragDropFile";




const ChatsWrapper = (
    {
        match,

        addingNewContactTouchForm,
        addingNewContactStateModal,
        addingNewContactToggleModal,
        addingNewContactRequestStart,
        addingNewContactErrors,
        addingNewContactLoading,

        importNewContactsTouchForm,
        importNewContactsStateModal,
        importNewContactsToggleModal,
        importNewContactsRequestStart,
        importNewContactsErrors,
        importNewContactsLoading,
    }
) => {
    const {t, i18n} = useTranslation();

    // --------------------------
    // Hooks
    // --------------------------
    // componentDidMount && componentWillUnmount



    const isMobile = isMobileDevice();

    const [addingNewContactPhone, setAddingNewContactPhone] = useState('');
    const [addingNewContactName, setAddingNewContactName] = useState('');

    useEffect(() => {
        if (!addingNewContactStateModal) {
            setAddingNewContactPhone('');
            setAddingNewContactName('');
            addingNewContactTouchForm();
        }
    }, [addingNewContactStateModal]);

    const sendAddingNewContactRequest = (e) => {
        e.preventDefault();
        addingNewContactRequestStart(addingNewContactName, addingNewContactPhone.replace(/[^+\d]/g, ''));
    }

    const [importNewContactsFile, setImportNewContactsFile] = useState('');

    useEffect(() => {
        if (!importNewContactsStateModal) {
            setImportNewContactsFile('');
            importNewContactsTouchForm();
        }
    }, [importNewContactsStateModal]);

    const sendImportNewContactsRequest = (e) => {
        e.preventDefault();
        importNewContactsRequestStart(importNewContactsFile.file);
    }

    return <Fragment>
        <AppHeader/>
        <div className="app-main">
            <AppSidebar/>
            <div className="app-main__outer position-fixed w-100">
                <div className="app-main__inner p-0 m-0">
                    <div className='app-inner-layout chat-layout'>
                        {
                            <Switch>
                                <Route
                                    exact path={`${match.url}/`}
                                    render={
                                        (props) => <Fragment>
                                            {
                                                isMobile &&
                                                <div className="app-inner-layout__wrapper flex-column">
                                                    <Chats/>
                                                </div>
                                            }
                                            {
                                                !isMobile && <div className="app-inner-layout__wrapper">
                                                    <Card className="app-inner-layout__sidebar">
                                                        <Chats/>
                                                    </Card>
                                                    <Card className="app-inner-layout__content"/>
                                                    <Card className='app-inner-layout__right-col'/>
                                                </div>
                                            }
                                        </Fragment>
                                    }
                                />
                                <Route
                                    exact path={`${match.url}/:activeChatId/`}
                                    render={
                                        ({match}) => {
                                            return <Fragment>
                                                {
                                                    isMobile &&
                                                    <div className="app-inner-layout__wrapper flex-column">
                                                        <Messages

                                                            match={match}
                                                        />
                                                    </div>
                                                }
                                                {
                                                    !isMobile &&
                                                    <div className="app-inner-layout__wrapper">
                                                        <Card className="app-inner-layout__sidebar">
                                                            <Chats

                                                                match={match}
                                                            />
                                                        </Card>
                                                        <Card className="app-inner-layout__content">
                                                            <Messages

                                                                match={match}
                                                            />
                                                        </Card>
                                                        <Card className='app-inner-layout__right-col'>
                                                            <ChatDetail/>
                                                        </Card>
                                                    </div>
                                                }
                                            </Fragment>
                                        }
                                    }
                                />
                            </Switch>
                        }
                    </div>
                </div>
            </div>
        </div>

        <Modal isOpen={addingNewContactStateModal}
               toggle={() => addingNewContactToggleModal(!addingNewContactStateModal)}>
            <ModalHeader>{t('chats.modal_adding_new_contact.adding_a_new_contact', "Adding a new contact")}</ModalHeader>
            <ModalBody>
                <Form onSubmit={sendAddingNewContactRequest} autoComplete="on">
                    <FormGroup>
                        <Label
                            for="phoneContact">{t('chats.modal_adding_new_contact.phone_number', "Phone number")} *</Label>
                        <Input type="text" name="phone_contact" id="phoneContact"
                               placeholder={t('chats.modal_adding_new_contact.phone', "Phone")}
                               required
                               value={addingNewContactPhone}
                               onChange={e => setAddingNewContactPhone(e.target.value)}
                               onClick={addingNewContactTouchForm}/>
                    </FormGroup>
                    <FormGroup>
                        <Label
                            for="nameContact">{t('chats.modal_adding_new_contact.contact_name', "Contact name")}</Label>
                        <Input type="text" name="name_contact" id="nameContact"
                               placeholder={t('chats.modal_adding_new_contact.name', "Name")}
                               value={addingNewContactName}
                               onChange={e => setAddingNewContactName(e.target.value)}
                               onClick={addingNewContactTouchForm}/>
                    </FormGroup>
                    <ButtonWithSpinner title={t('chats.modal_adding_new_contact.send_in', "Send in")}
                                       type="submit" loading={addingNewContactLoading}
                                       disabled={addingNewContactPhone.length < 11}/>
                    <div className="text-danger mr-3 mt-3">{get(addingNewContactErrors, 'common')}</div>
                </Form>
            </ModalBody>
        </Modal>

        <Modal isOpen={importNewContactsStateModal}
               toggle={() => importNewContactsToggleModal(!importNewContactsStateModal)}>
            <ModalHeader>{t('chats.modal_import_new_contacts.import_new_contacts', "Import new contacts")}</ModalHeader>
            <ModalBody>
                <Form onSubmit={sendImportNewContactsRequest} autoComplete="on">
                    <FormGroup>
                        <DragDropFile
                            handleChange={setImportNewContactsFile}
                            handleClick={importNewContactsTouchForm}
                            title={t('chats.modal_import_new_contacts.to_add_a_file', "To add a file")}
                            fileTypes={["text/csv"]} />
                    </FormGroup>
                    <div
                        className="text-center mt-3 mb-3">{t('chats.modal_import_new_contacts.import_new_contacts_description', "Import new contacts description")}</div>
                    <div className="d-flex justify-content-center">
                        <ButtonWithSpinner title={t('chats.modal_import_new_contacts.upload', "Upload")}
                                           type="submit" loading={importNewContactsLoading}
                                           disabled={!importNewContactsFile.file || importNewContactsFile.fileType != "text/csv"}/>
                    </div>
                    <div className="text-center text-danger mt-3">{get(importNewContactsErrors, 'common')}</div>
                    <div className="text-danger mr-3 mt-3">{get(importNewContactsErrors, 'phone_invalid')}</div>
                </Form>
            </ModalBody>
        </Modal>

    </Fragment>;
};


const mapStateToProps = state => ({

    addingNewContactStateModal: state.Chats.addingNewContactStateModal,
    addingNewContactErrors: state.Chats.addingNewContactErrors,
    addingNewContactLoading: state.Chats.addingNewContactLoading,
    importNewContactsStateModal: state.Chats.importNewContactsStateModal,
    importNewContactsErrors: state.Chats.importNewContactsErrors,
    importNewContactsLoading: state.Chats.importNewContactsLoading,
});

const mapDispatchToProps = dispatch => ({

    addingNewContactTouchForm: () => dispatch(addingNewContactTouchForm()),
    addingNewContactToggleModal: (bool) => dispatch(addingNewContactToggleModal(bool)),
    addingNewContactRequestStart: (name, phone) => dispatch(addingNewContactRequestStart(name, phone)),
    importNewContactsTouchForm: () => dispatch(importNewContactsTouchForm()),
    importNewContactsToggleModal: (bool) => dispatch(importNewContactsToggleModal(bool)),
    importNewContactsRequestStart: (file) => dispatch(importNewContactsRequestStart(file)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatsWrapper);
